//import AlertPopup,{default_alert_popup_data} from "@/pcomponents/common/content/popup/alert";
/*
setPopupData({...default_alert_popup_data,
  msg: "좌석사용 학생이 아닙니다.",
});
{popupData.isOpen &&
  <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
    width={popupData.width} height={popupData.height} has_header={popupData.has_header}
    is_show_close_btn={popupData.is_show_close_btn}>
    {popupData.sort === "alert" &&
      <AlertPopup
        msg={popupData.msg}
        closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
        callBackData={popupData.callBackData}
      ></AlertPopup>
    }
  </LayerPopup>
}
*/
import { useRef, useEffect } from 'react';

export const default_alert_popup_data={
  isOpen: true,
  title: "Message.",
  msg: "좌석사용 학생이 아닙니다.",
  callBackData: () => { },
  sort: "alert",
  y: "",
  is_border_radius: false,
  has_header: true,
  is_show_close_btn: false,
  width: "350px",
  height: "120px",
};
function AlertPopup(props: any) {
  let myProps = {
    msg:"Message.",
    closePopup: () => {},
    callBackData:()=>{},
    ...props
  };

  let close_button_ref=useRef<any>(null);
  useEffect(()=>{
    if(close_button_ref.current){
      close_button_ref.current.focus();
    }
  },[]);

  return (
    <div className="text-center noto_sans">
      <div style={{ fontSize: "15px" }}>
        {myProps.msg}
      </div>
      <div className="mt-2 text-center">
        <button className="btn btn-gray-text btn-medium-w"
          ref={close_button_ref}
          onClick={() => {
            myProps.closePopup();
            myProps.callBackData();
          }}>닫기</button>
      </div>
    </div>
  );
};
export default AlertPopup;